<div *ngIf="isLoading$ | async" class="tab-spinner-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<div *ngIf="(isLoading$ | async) === false && (matchesResult$ | async) as result">

  <ng-container *ngIf="result.data.length > 0; else noResultsTemplate">

    <div class="match-cards-grid">
      <app-statistics-match-card
        *ngFor="let match of result.data"
        [match]="match">
      </app-statistics-match-card>
    </div>

    <mat-paginator
      *ngIf="result.total_results > result.page_size"
      [length]="result.total_results"
      [pageSize]="result.page_size"
      [pageIndex]="result.page - 1"
      (page)="handlePageEvent($event)"
      [showFirstLastButtons]="true"
      aria-label="Seleccionar página">
    </mat-paginator>
  </ng-container>

  <ng-template #noResultsTemplate>
    <div class="no-results-container">
      <mat-icon>search_off</mat-icon>
      <p>No se encontraron partidos para los filtros seleccionados.</p>
    </div>
  </ng-template>

</div>

<div *ngIf="(isLoading$ | async) === false && (matchesResult$ | async) === null" class="no-results-container">
  <mat-icon>filter_list</mat-icon>
  <p>Selecciona una Temporada y Competición para iniciar la búsqueda.</p>
</div>
